// extracted by mini-css-extract-plugin
export default {"wrapper":"MapActionButton_wrapper__FMyp5","icon":"MapActionButton_icon__LSjLW","detail_btn":"MapActionButton_detail_btn__REA1r"};